/*
 * @Description: 国安英文
 * @Author: zml
 * @Date: 2023-03-23 14:52:59
 * @LastEditors: zml
 * @LastEditTime: 2025-02-10 14:32:07
 */
export default {
    "LLH.login":"Sign In",
    "LLH.register":"Register",
    "LLH.logout":"Logout",
    "LLH.MyOrder":"My Order",
    "LLH.logoBox.placeholder": "Please enter the product keyword",
    "LLH.logoBox.search": "Search",
    "LLH.logoBox.AdvancedSearch": "Advanced Search",
    "LLH.nav.Home": "HOME",
    "LLH.nav.Products": "PRODUCTS",
    "LLH.nav.About": "ABOUT US",
    "LLH.nav.contact": "CONTACT US",
    "LLH.nav.news": "NEWS",
    "LLH.nav.cart": "CART",
    "LLH.ViewPrice": "View Price",
    "LLH.SameFactory": "Same Factory",
    "LLH.newPro": "NEW ARRIVIALS",
    "LLH.AnotherBatch": "Another Batch",
    "LLH.ViewMore": "View More",
    "LLH.hotPro": "HOT ITEMS",
    "LLH.hotVidio": "HOT ITEM VODEO",
    "LLH.proUnBoxVidio": "PRODUCT UNBOXING VIDEO",
    "LLH.Search": "SEARCH",
    "LLH.Reset": "RESET",
    "LLH.ItemNO": "Item NO.",
    "LLH.MTCode": "MT Code",
    "LLH.FTYCode": "FTY Code",
    "LLH.Kind": "Kind",
    "LLH.Size": "Size",
    "LLH.Price": "Price",
    "LLH.Date": "Date",
    "LLH.Sort": "Sort",
    "LLH.DateDesc": "DATE DESC",
    "LLH.DateAsc": "DATE ASC",
    "LLH.PriceDesc": "PRICE DESC",
    "LLH.PriceAsc": "PRICE ASC",
    "LLH.NO.Desc": "NO. DESC",
    "LLH.NO.Asc": "NO. ASC",
    "LLH.PleaseEnterTheProductNameKeyword": "Please enter the product name keyword",
    "LLH.PleaseSelect": "Please select",
    "LLH.PleaseLength": "Length",
    "LLH.PleaseWidth": "Width",
    "LLH.PleaseHeight": "Height",
    "LLH.PleaseMinPrice": "Min price",
    "LLH.PleaseMaxPrice": "Max price",
    "LLH.PleaseStartDate": "Start date",
    "LLH.PleaseEndDate": "End date",
    "LLH.UserAccount": "User Account",
    "LLH.password": "Password",
    "LLH.GROUPSEARCH": "GROUPSEARCH",
    "LLH.Video_playback": "Video playing",
    "LLH.loginMsg": "Access your account and order history",
    "LLH.onUserAccount": "New Customer",
    "LLH.SignUp": "Start Here.",
    "LLH.ForgetPassword": "Forget password",
    "LLH.resetPasswords": "Reset password",
    "LLH.emailAddress": "Email address",
    "LLH.verifyCode": "Verify code",
    "LLH.getVerifyCode": "Get code",
    "LLH.newPassword": "New password",
    "LLH.confirmPassword": "Confirm password",
    "LLH.Submit": "Submit",
    "LLH.SignUpAccount": "Sign up",
    "LLH.LoginOnly": "Login only",
    "LLH.Name": "Name",
    "LLH.NameMsg": "Please enter your name, 2 to 30 characters",
    "LLH.passwordMsg": "At least 6 characters",
    "LLH.requiredFields": "*Required fields",
    "LLH.Email": "Email",
    "LLH.EmailMsg": "Please enter email. Used for login",
    "LLH.gender": "Gender",
    "LLH.man": "Mr.",
    "LLH.woman": "Ms.",
    "LLH.customerSource": "Customer source",
    "LLH.salesman": "Contact Salesman",
    "LLH.Country": "Country",
    "LLH.companyName": "Company name",
    "LLH.duty": "Job Titel",
    "LLH.tel": "Tel",
    "LLH.mobile": "Mobile",
    "LLH.fax": "Fax",
    "LLH.Yahoo": "Yahoo",
    "LLH.website": "Website",
    "LLH.address": "Address",
    "LLH.postalCode": "Postal code",
    "LLH.ExistingAccount": "Existing account",
    "LLH.DirectLogin": "Direct login",
    "LLH.productPrice": "Price",
    "LLH.ProductNumber": "Item NO.",
    "LLH.Packing": "Packing",
    "LLH.OuterBoxCBM": "CBM",
    "LLH.OuterBoxCUFT": "CUFT",
    "LLH.Innerboxes": "Inner Boxes",
    "LLH.OuterQTY": "Outer QTY",
    "LLH.GWAndNW": "G.W/N.W",
    "LLH.productSize": "Product Size",
    "LLH.packageSize": "Package Size",
    "LLH.cartonSize": "Carton Size",
    "LLH.addCart": "Add To Cart",
    "LLH.delCart": "Remove from Cart",
    "LLH.product": "PRODUCTS",
    "LLH.NewsUpdates": "News Updates",
    "LLH.ReleaseDate":"Release Date",
    "LLH.MyCart":"My Cart",
    "LLH.ID":"ID",
    "LLH.picture":"Picture",
    "LLH.ArticleNo":"Item No.",
    "LLH.Description":"Product Name",
    "LLH.CartOuterQTY":"Outer QTY",
    "LLH.CBM":"CBM",
    "LLH.CTNS":"CTNS",
    "LLH.totalQTY": "Total QTY",
    "LLH.TotalVolume":"Total CBM",
    "LLH.total":"Total",
    "LLH.delete":"Delete",
    "LLH.checkAll":"Check All",
    "LLH.clear":"Clear",
    "LLH.totalItems": "Total Items",
    "LLH.totalCTNS": "Total CTNS",
    "LLH.noData": "No Data",
    "LLH.totalPrice": "Total Price",
    "LLH.systemTip": "Tip",
    "LLH.confirm": "Confirm",
    "LLH.cancel": "Cancel",
    "LLH.deleteData": "Do you want to delete the data?",
    "LLH.clearCartData": "Do you want to empty your shopping cart?",
    "LLH.submitTip": "Confirm to submit the order?",
    "LLH.MyOrder": "My Order",
    "LLH.PleaseOrderNum": "Please enter the order number",
    "LLH.number": "Number",
    "LLH.viewDetails": "View Details",
    "LLH.orderTime": "Creation time",
    "LLH.linkman": "Linkman",
    "LLH.sendDate": "Delivery Date",
    "LLH.expressNumber": "Tracking Number",
    "LLH.orderStatus": "Order Status",
    "LLH.unshipped": "Unshipped",
    "LLH.shipped": "Shipped",
    "LLH.SiteNavigation": "Site Navigation",
    "LLH.ContactUs": "Contact Us",
    "LLH.FollowUs": "Follow Us",
    "LLH.Landline": "Landline",
    "LLH.Email": "E-mail",
    "LLH.Phone": "Phone",
    "LLH.WeChat": "WeChat",
    "LLH.Technic": "Technic Sustain",
    "LLH.Software": "HongSheng Soft",
    "LLH.detailBtn": "Product details",
    "LLH.noDetailBtn": "No product details",
    "LLH.classify": "CATALOG",
    "LLH.exclusive": "EXCLUSIVE RECOMMENDATIONS",
    "LLH.loading": "Loading...",
    "LLH.updateTime": "UpdateTime",
    "LLH.SearchMsg": "The above search criteria can be any one or more comprehensive searches",
    "LLH.MessageTitle": "Submit your requirements online",
    "LLH.MessageMsg": "We will reply to your email within 24 hours, excluding holidays",
    "LLH.MessageName": "YOUR NAME",
    "LLH.MessageTel": "YOUR PHONE",
    "LLH.MessageEmail": "YOUR EMAIL",
    "LLH.MessageNeeds": "YOUR NEEDS",
    "LLH.SendInquiry": "Send Inquiry",
    "LLH.EnquiryList": "ENQUIRY",
    "LLH.enquiry": "Enquiry",
    "LLH.MyEnquiryList": "My Inquiry Form",
    "LLH.Remark": "Remark",
    "LLH.Enquirys": "Leave your email and we'll get back to you",
    "LLH.proClass": "Product Category",
    "LLH.submitOrder": "Confirm submitting the inquiry?",
}   
